<template>
  <div class="position-relative">
    <a ref="monthSwitch"
       @click="showPopup"
       class="d-inline-block mr-md-3 mr-2 view-active-type one-line-text-with-icon text-capitalize pointer">
      {{ formatDate(month.date, 'MMMM, YYYY') }} <Arrow />
    </a>
    <transition name="fade" mode="out-in">
      <div v-if="popupShowed">
        <div class="view-dd-selector position-absolute py-3 overflow-auto"
             v-closable="{
            exclude: ['monthSwitch'],
            handler: 'onClose'
        }">
          <a class="d-block dropdown-item pointer text-capitalize"
             :class="{ 'text-muted': m.status }"
             v-for="m in month.available_months"
             @click="selectMonth(m)"
             :key="`m-${m.id}`">
            <LockSvg v-if="m.status"
                     class="mr-2 svg-size-md svg-light"/>
            <div class="d-inline-block align-middle mr-2 text-center" v-else style="width: 14px">
              <span class="generic-bubble blue-bubble"></span>
            </div>
            <div class="d-inline-block align-middle">{{ formatDate(m.date, 'MMMM, YYYY') }}</div>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import Arrow from "@/assets/svg-vue/calendar/arrow.svg.vue"
// import LockOpenedSvg from '@/assets/svg-vue/general/lock_opened.svg'
import LockSvg from '@/assets/svg-vue/general/lock.svg'
// import LockSvg from '@/assets/svg-vue/calendar/record_blocked.svg'
import {formatDate} from "@/extensions/filters/filters"
import {ref} from "vue"
import {useRouter} from "vue-router"

defineProps({
  month: {
    type: Object,
    required: true
  },
})

const router = useRouter()

const popupShowed = ref(false)

const showPopup = () => {
  popupShowed.value = !popupShowed.value
}

const onClose = () => {
  popupShowed.value = false
}

defineExpose({
  onClose
})

const selectMonth = (m) => {
  popupShowed.value = false
  router.push({ name: 'AccountingMonthSummary', params: { id: m.id } })
}
</script>

<style scoped lang="scss">
.view-dd-selector {
  max-height: 70vh;
}
.dropdown-item {
  font-size: 90%;
  color: #2c3e50;
}
</style>
